<template>
  <div class="mb-10 flex size-full flex-col items-center md:max-w-7xl md:px-5 lg:px-10">
    <div class="mb-3 flex w-full items-center px-2 md:px-0">
      <div class="flex w-full flex-col px-3 py-6 sm:px-4 md:p-5 lg:px-6 xl:px-7">
        <h1 class="mb-4 flex w-full items-center justify-between font-serif text-gray-700 md:text-2xl lg:text-3xl">
          <span>Mis Productos Favoritos</span>
          <span class="text-sm md:text-base">{{ totalResources }}</span>
        </h1>
        <div class="flex w-full flex-col rounded-md bg-white px-2 py-4 md:px-4 md:py-8 lg:px-10">
          <div
            v-if="loading"
            class="mb-10 grid w-full grid-cols-2 gap-x-3 gap-y-4 sm:grid-cols-3 md:grid-cols-3 md:gap-x-4 md:gap-y-6 lg:grid-cols-4 lg:gap-x-5 lg:gap-y-8"
          >
            <product-card-placeholder
              v-for="(_, index) in new Array(productsPerPage)"
              :key="`fake-product-card-${index}`"
              :odd-position="index % 2 === 0"
            />
          </div>
          <div
            v-else-if="!currentProducts.length"
            class="rounded-lg border border-gray-200 bg-white p-6 text-center"
          >
            <p class="text-lg text-gray-600">No tienes productos favoritos todavía.</p>
            <a
              href="/products"
              class="mt-4 inline-block rounded-md bg-lk-green px-4 py-2 text-white"
            >
              Explorar productos
            </a>
          </div>
          <div
            v-else
            class="mb-10 grid w-full grid-cols-2 gap-x-3 gap-y-4 sm:grid-cols-3 md:grid-cols-3 md:gap-x-4 md:gap-y-6 lg:grid-cols-4 lg:gap-x-5 lg:gap-y-8"
          >
            <liked-product-card
              v-for="product in currentProducts"
              :key="product.id"
              :product="product"
            />
          </div>
          <pagination-component
            v-if="!loading && currentProducts?.length && totalPages > 1"
            :total-pages="totalPages"
            :current-page="currentPage"
            @set-new-page="updateNewPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useQuery } from 'vue-query';
import useSessionStore from 'stores/user-store';
import productLikesApi from 'api/product-likes';
import ProductCardPlaceholder from './product-card-placeholder.vue';
import PaginationComponent from './shared/pagination-component.vue';
import useCustomParseInt from './use/custom-parse-int';
import LikedProductCard from './liked-product-card.vue';

const productsPerPage = 24;

const sessionStore = useSessionStore();
const currentPage = ref(1);

const likedProductsQuery = useQuery(
  ['likedProducts', currentPage],
  () => productLikesApi.index(currentPage.value, productsPerPage),
  {
    keepPreviousData: true,
    enabled: !!sessionStore.user?.id,
  },
);

const currentProducts = computed(() => likedProductsQuery.data.value?.data.products || []);
const totalResources = computed(() => useCustomParseInt(likedProductsQuery.data.value?.headers['x-total']));
const resourcesPerPage = computed(() => useCustomParseInt(likedProductsQuery.data.value?.headers['x-per-page']));
const totalPages = computed(() => Math.ceil(totalResources.value / resourcesPerPage.value));
const loading = computed(() => likedProductsQuery.isLoading.value || likedProductsQuery.isPreviousData.value);

function updateNewPage(page: number) {
  currentPage.value = page;
}
</script>
